module.exports = __webpack_public_path__ + "img/file-shared-logo.f3ef8ce4.png";